import { get } from 'lodash-es';
import { useEffect } from 'react';

import { billingActions } from '@store/subscription/subscription.slice';

import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useLazyLoadSubscriptionQuery } from '@hook/billing/billing.hooks';
import { useLazyQuery } from '@hook/common/use-lazy-query.hook';
import { useStoreSelector } from '@hook/store/store.hooks';
import { isExist } from '@util/data/is-exist';

export const useSubscription = () => {
  const application = useCurrentApplication();
  const subscription = useStoreSelector((state) => state.subscription);

  const accountId = get(application, 'current.account.id');
  const subscriptionAccountId = get(subscription, 'data.plan.accountId');

  const { action } = useLazyQuery(useLazyLoadSubscriptionQuery(), billingActions, billingActions.setData);

  useEffect(
    () => void (isExist(accountId) && subscriptionAccountId !== accountId && action(accountId)),
    [accountId, subscriptionAccountId],
  );

  return subscription;
};
